<template>
  <div>
    <v-row class="mb-4">
      <Breadcrump class="mb-2" :crumbs="crumbs" />
      <v-spacer></v-spacer>

      <v-expansion-panels accordion>
        <v-expansion-panel v-for="(item, i) in complexes" :key="i">
          <v-expansion-panel-header
            disable-icon-rotate
            @click="clearPrevious(item.id)"
          >
            {{ item.name }}
            <template v-slot:actions>
              <v-icon v-if="item.open" color="error">mdi-alert-circle</v-icon>
              <v-icon v-else color="teal">mdi-check</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-expansion-panels multiple>
              <v-expansion-panel v-for="(child, i) in item.children" :key="i">
                <v-expansion-panel-header disable-icon-rotate>
                  {{ child.name }}
                  <template v-slot:actions>
                    <v-icon v-if="child.open" color="error"
                      >mdi-alert-circle</v-icon
                    >
                    <v-icon v-else color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panels multiple>
                    <v-expansion-panel
                      v-for="(device, i) in child.devices"
                      :key="i"
                    >
                      <v-expansion-panel-header disable-icon-rotate>
                        {{ device.name }}
                        <template v-slot:actions>
                          <v-icon v-if="device.isOnline" color="teal"
                            >mdi-wifi</v-icon
                          >
                          <v-icon v-else color="error">mdi-wifi-off</v-icon>
                          <v-icon v-if="device.caseDoorFlag" color="error"
                            >mdi-door-open</v-icon
                          >
                          <v-icon v-else color="teal">mdi-door</v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-btn
                          :loading="loading"
                          color="primary"
                          @click="getDeviceLastState(device.id)"
                        >
                          دریافت آخرین وضعیت دستگاه
                        </v-btn>
                        آخرین تغییر {{ device.modifyDate }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import request from "@/utils/request";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default {
  name: "DeviceAndComplex",
  components: {
    Breadcrump
  },
  data() {
    return {
      crumbs: [
        {
          text: "خانه",
          disabled: false,
          href: "/"
        },
        {
          text: "وضعیت دستگاه‌ها",
          href: `/device-and-complex`,
          disabled: true
        }
      ],
      name: null,
      complexes: [],
      devices: [],
      loading: true
    };
  },
  created() {
    this.complexestree();
  },
  methods: {
    async getDeviceLastState(item) {
      this.loading = true;
      request
        .get(`/device/getDeviceLastState/${item}`)
        .then(() => {
          this.complexestree();
        })
        .catch(error => {
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async clearPrevious(comId) {
      this.devices = [];
    },
    async getDevices(item) {
      this.loading = true;
      await request
        .get(`/device/complex-devices/${item}`)
        .then(response => {
          this.devices = response.data.result;
        })
        .catch(error => {
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async complexestree() {
      this.loading = true;
      await request
        .get(`/complex/complexes-tree`)
        .then(response => {
          this.complexes = response.data.result;
        })
        .catch(error => {
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
